// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2_9K6","content":"GlobalSearch_content__1hqhU"};